<template>
  <div class="box">
    <form class="section" @submit.prevent="submitData()">
      <div class="field">
        <label class="label">Service</label>
        <div class="control">
          <div class="select">
            <select v-model="service">
              <option value="">Select Service</option>
              <option v-for="(service_row, index) in service_list" :value="service_row.id" :key="index" v-text="service_row.title"></option>
            </select>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">Event</label>
        <div class="control">
          <div class="select">
            <select v-model="event">
              <option value="">Select Event</option>
              <option v-for="(event_row, index) in event_list" :value="event_row.id" :key="index" v-text="event_row.title"></option>
            </select>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">Receive Tickets</label>
        <div class="control">
          <input type="number" class="input" v-model="tickets">
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" type="submit">Submit</button>
        </div>
      </div>
    </form>
    <table class="table is-fullwidth">
      <tr>
        <th>Event</th>
        <th>Service</th>
        <th>Tickets</th>
      </tr>
      <tr v-for="(event_service_row, index) in event_service_list" :key="index">
        <td v-text="event_service_row.event_title"></td>
        <td v-text="event_service_row.service_title"></td>
        <td v-text="event_service_row.tickets"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      service_list: [],
      service: '',
      event_list: [],
      event: '',
      tickets: 0,
      event_service_list: []
    }
  },
  created () {
    this.getService()
    this.getEvent()

    this.getEventService()
  },
  methods: {
    getEventService () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('head/event_service/')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.event_service_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getService () {
      var self = this
      self.flyGet('new_people/get_services')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.service_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getEvent () {
      var self = this
      self.flyGetSession('frontdesk/get_event')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.event_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('head/event_service/insert', {
        service: this.service,
        event: this.event,
        tickets: this.tickets
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.$geb.emit({id: 'alert_modal', title: 'Success!', content: 'Data anda sudah masuk!', button_text: 'OK'})
          self.event_service_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/EventService.vue